// @flow

import './theme/tailwind.css';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { SavedFundingMethodController } from './saved-funding-method';
import { PixJsrEnrollmentController } from '@tectonics/features/jornada-sem-redirecionamento/pix-enrollment';
import { PixJsrPaymentController } from '@tectonics/features/jornada-sem-redirecionamento/pix-payment';
import { YapeHostedPaymentController } from './yape-hosted-payment';
import { Controller } from './controller';
import { PublicEventBusContext, PublicEventBus } from './public-event-bus';
export class Tectonics {
  actionOrHash: ?string;
  lookAndFeelCode: ?string;
  tenant: ?string;

  bus = new PublicEventBus();
  el = document.createElement('section');
  root = null;

  constructor(actionOrHash?: string, lookAndFeelCode?: string, tenant?: string) {
    this.actionOrHash = actionOrHash;
    this.lookAndFeelCode = lookAndFeelCode;
    this.tenant = tenant;
    this.renderRoot();
  }

  renderRoot() {
    if (!this.actionOrHash) {
      throw new Error('Tectonics - missing action or hash');
    }
    const action = this.actionOrHash;
    if (action.startsWith('saved-funding-method')) {
      this.renderSavedFundingMethodRoot();
    } else if (action.startsWith('pix-jsr-enrollment')) {
      this.renderPixJsrEnrollmentRoot();
    } else if (action.startsWith('pix-jsr-payment')) {
      this.renderPixJsrPaymentRoot();
    } else if (action.startsWith('yape-hosted-payment')) {
      this.renderYapeHostedPaymentRoot();
    } else {
      this.renderPaymentPageRoot();
    }
  }

  renderSavedFundingMethodRoot() {
    const action = ((this.actionOrHash: any): string);

    this.root = createRoot(this.el);
    this.root.render(
      <SavedFundingMethodController
        action={action}
        tenantCode={this.tenant}
        lookAndFeelCode={this.lookAndFeelCode}
      />
    );
  }

  renderPixJsrEnrollmentRoot() {
    this.root = createRoot(this.el);
    this.root.render(
      <PixJsrEnrollmentController
        tenantCode={this.tenant}
      />
    );
  }

  renderPixJsrPaymentRoot() {
    this.root = createRoot(this.el);
    this.root.render(
      <PixJsrPaymentController
        tenantCode={this.tenant}
      />
    );
  }

  renderYapeHostedPaymentRoot() {
    this.root = createRoot(this.el);
    this.root.render(
      <YapeHostedPaymentController
        tenantCode={this.tenant}
      />
    );
  }

  renderPaymentPageRoot() {
    const hash = ((this.actionOrHash: any): string);

    this.root = createRoot(this.el);
    this.root.render(
      <PublicEventBusContext.Provider value={this.bus}>
        <Controller
          hash={hash}
          lookAndFeelCode={this.lookAndFeelCode || undefined}
          localTenancy={this.tenant || undefined}
        />
      </PublicEventBusContext.Provider>
    );
  }


  renderTo(root: HTMLDivElement) {
    const {el} = this;
    if (el.parentElement !== root) {
      root.appendChild(el);
    }
  }

  destroy() {
    const {el} = this;
    el.remove();
    if (this.root) {
      this.root.unmount();
    }
  }
  on = this.bus.on.bind(this.bus);
  off = this.bus.off.bind(this.bus);
  trigger = this.bus.trigger.bind(this.bus);
}

window.Tectonics = Tectonics;
